import React, { useState, useEffect } from 'react';
import { FormGroup } from 'src/components/ui';
import InputMask from 'react-input-mask';
import { useDebouncedEffect } from '../../hooks/useDebounceEffect';
import useTestId from '../../hooks/useTestId';
import { useAutofillSafeName } from '../../hooks/useAutofillSafeName';

export default function PhoneInput({ id, value, formData, required, disabled, readonly, autofocus, onChange: propOnChange }) {
  const [current, setCurrent] = useState(value);
  const testIdProps = useTestId(id);
  const autofillSafeName = useAutofillSafeName();

  useDebouncedEffect(
    () => {
      if (current !== value) {
        propOnChange(current);
      }
    },
    [current],
    300
  );

  useEffect(() => setCurrent(value), [value]);

  return (
    <FormGroup>
      <InputMask
        mask="(999)999-9999"
        disabled={disabled}
        name={autofillSafeName}
        autoComplete="off"
        className="form-control"
        value={current || ''}
        required={required}
        onChange={e => setCurrent(e.target.value)}
        readOnly={readonly}
        autoFocus={autofocus}
        id={id}
        {...testIdProps}
      />
    </FormGroup>
  );
}
